export const UserRoles = [
    "Account Manager", "Accountant", "Admin", "Administrative Assistant",
    "Auditor", "Benefits Administrator", "Bookkeeper", "Brand Manager",
    "Call Center Agent", "Chief Executive Officer (CEO)",
    "Chief Financial Officer (CFO)", "Chief Human Resources Officer (CHRO)",
    "Chief Information Officer (CIO)", "Chief Marketing Officer (CMO)",
    "Chief Operating Officer (COO)", "Chief Technology Officer (CTO)",
    "Compensation Analyst", "Compliance Officer", "Contract Administrator",
    "Controller", "Customer Service Representative", "Customer Success Manager",
    "Data Entry Clerk", "Data Scientist", "Database Administrator", "Designer",
    "Digital Marketing Specialist", "Director", "Executive Assistant",
    "Financial Analyst", "Help Desk Technician", "HR Generalist", "HR Manager",
    "Human Resources Assistant", "Inventory Manager", "Legal Counsel",
    "Logistics Coordinator", "Manager", "Marketing Coordinator",
    "Network Administrator", "Office Manager", "Operations Manager",
    "Paralegal", "Procurement Specialist", "Receptionist", "Recruiter",
    "Regulatory Affairs Specialist", "Risk Manager", "Sales Manager",
    "Sales Representative", "Software Engineer", "Supervisor",
    "Supply Chain Analyst", "Systems Analyst", "Tax Specialist", "Team Lead",
    "Technical Support Specialist", "Training Coordinator",
    "Vice President (VP)", "Warehouse Supervisor", "TeamLead", "User",
    "Web Developer"
];